import React, {useMemo} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import UseReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters}) => {
    const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

    const {
        specificDispatchNatures,
        specificDispatchNaturesGroups,
        allTeams,
        placeNames,
        placeTypes,
        streetNames,
        neighborhood
    } = UseReportFiltersFetch({
        specificDispatchNatures: true,
        specificDispatchNaturesGroups: true,
        fetchAllTeams: true,
        fetchPlaceNames: true,
        fetchNeighborhood: true,
        fetchPlaceTypes: true,
        fetchStreetNames: true
    });

    const natures = useMemo(() => [{ label: "Não informado", value: "WITHOUT-NATURE" }, ...specificDispatchNatures],
      [specificDispatchNatures])
    const natureGroups = useMemo(() => [{ label: "Não informado", value: "WITHOUT-NATURE-GROUP" }, ...specificDispatchNaturesGroups],
      [specificDispatchNaturesGroups])
    const streets = useMemo(() => [{ label: "Não informado", value: "WITHOUT-STREET" }, ...streetNames],
      [streetNames])
    const places = useMemo(() => [{ label: "Não informado", value: "WITHOUT-PLACE" }, ...placeNames],
      [placeNames])
    const pTypes = useMemo(() => [{ label: "Não informado", value: "WITHOUT-TYPE-PLACE" }, ...placeTypes],
      [placeTypes])
    const neighborhoods = useMemo(() => [{ label: "Não informado", value: "WITHOUT-NEIGHBORHOOD" }, ...neighborhood],
      [neighborhood])
    const teams = useMemo(() => [{ label: "Não informado", value: "WITHOUT-TEAM" }, ...allTeams],
      [allTeams])

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        istanceId="nature"
                        label="Natureza"
                        isMulti={true}
                        options={natures}
                        value={natures?.filter(el => filters.nature?.includes(el))}
                        onChange={selected => handleSpecialInput("nature", selected)}
                    />

                    <SelectComponent
                      istanceId="natureGroup"
                      label="Grupo de natureza"
                      isMulti={true}
                      options={natureGroups}
                      value={natureGroups.filter(el => filters.nature_group?.includes(el))}
                      onChange={selected => handleSpecialInput("nature_group", selected)}
                    />

                    <SelectComponent
                      istanceId="teams"
                      label="Equipe"
                      isMulti={true}
                      options={teams}
                      value={teams.filter(el => filters.team?.some(f => f.value === el.value))}
                      onChange={selected => handleSpecialInput("team", selected)}
                    />

                    <SelectComponent
                      istanceId="street"
                      label="Logradouro"
                      isMulti={true}
                      options={streets}
                      value={streets.filter(el => filters.street?.includes(el))}
                      onChange={selected => handleSpecialInput("street", selected)}
                    />

                    <SelectComponent
                      istanceId="place"
                      label="Local pré-cadastrado"
                      isMulti={true}
                      options={places}
                      value={places.filter(el => filters.place?.includes(el))}
                      onChange={selected => handleSpecialInput("place", selected)}
                    />

                    <SelectComponent
                      istanceId="placeType"
                      label="Tipo de local"
                      isMulti={true}
                      options={pTypes}
                      value={pTypes.filter(el => filters.type_place?.includes(el))}
                      onChange={selected => handleSpecialInput("type_place", selected)}
                    />

                    <SelectComponent
                      istanceId="neighborhood"
                      label="Bairro"
                      isMulti={true}
                      options={neighborhoods}
                      value={neighborhoods.filter(el => filters.neighborhood?.includes(el))}
                      onChange={selected => handleSpecialInput("neighborhood", selected)}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;